
const baseConfig = {
  appName: 'Team Up For Impact',
  encrypt(msg: string) {
    // TODO encrypt message here
    return msg;
  },
};

const prodConfig = {
  ...baseConfig,
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',
  apiUri: 'https://api.teamupforimpact.org/api/v1/',
  cdnUri: 'https://api.teamupforimpact.org/',
  appUri: 'https://teamupforimpact.org/',
  socketUri: 'https://chat-api.teamupforimpact.org',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
};

const devConfig = {
  ...baseConfig,
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',
  apiUri: 'https://demoapi.teamupforimpact.org/api/v1/',
  cdnUri: 'https://demoapi.teamupforimpact.org/',
  appUri: 'https://teamupforimpact.org/',
  socketUri: 'https://chat-api-demo.teamupforimpact.org',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
};

const localConfig = {
  ...baseConfig,
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',
  apiUri: 'http://localhost:5204/api/v1/',
  cdnUri: 'http://localhost:5204/',
  appUri: 'https://teamupforimpact.org/',
  socketUri: 'http://localhost:5003',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
};

// production & development are built in node.js,
// local is manually set by command in package.json
const mode: 'production' | 'development' | 'local' = process.env.NODE_ENV;

const config = {
  production: prodConfig,
  development: devConfig,
  local: localConfig,
}[mode];

export default config;
